import { jsxs as L, jsx as C } from "react/jsx-runtime";
function l(r) {
  return /* @__PURE__ */ L(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M3.82747 25.0379H16.3561V13.5614H3.82747V25.0379ZM19.4225 25.2384C19.4225 26.8215 18.1396 28.1053 16.5566 28.1056H3.62695C2.04374 28.1056 0.759766 26.8217 0.759766 25.2384V13.3608C0.759766 11.7776 2.04374 10.4937 3.62695 10.4937H16.5566C18.1396 10.494 19.4225 11.7778 19.4225 13.3608V25.2384Z",
            fill: "rgb(var(--brand-primary))"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M21.5408 1.53356C25.0304 1.71055 27.8051 4.59622 27.8054 8.12975L27.7967 8.46995C27.6256 11.8438 24.9231 14.5474 21.5506 14.7235V12.5313C23.8265 12.3529 25.618 10.4514 25.6182 8.12975C25.6179 5.69045 23.6399 3.7123 21.2006 3.71209C18.7613 3.71237 16.7832 5.6905 16.7829 8.12975C16.7829 8.20716 16.7851 8.28465 16.7891 8.36109H14.6019L14.5957 8.12975C14.596 4.48234 17.5531 1.52519 21.2006 1.5249L21.5408 1.53356Z",
            fill: "rgb(var(--fill-primary))"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M21.2094 1.14502L21.5496 1.15368H21.5595C25.25 1.34113 28.1838 4.39292 28.1841 8.12965V8.13955L28.1755 8.47975V8.48965C27.9942 12.0579 25.136 14.9169 21.5694 15.1032L21.1698 15.1242V12.1799L21.5199 12.1527C23.4697 11.9998 25.031 10.4625 25.2188 8.52305L25.2374 8.12965C25.2371 5.96992 23.5402 4.20512 21.4073 4.09673L21.1995 4.09178C18.9701 4.09207 17.1619 5.90029 17.1616 8.12965L17.1678 8.3412L17.1876 8.74078H14.2309L14.2148 8.13955V8.12965C14.2151 4.27238 17.3422 1.14532 21.1995 1.14502H21.2094ZM25.6171 8.12965C25.6169 10.4513 23.8254 12.3528 21.5496 12.5312V14.7234C24.9221 14.5473 27.6245 11.8437 27.7957 8.46986L27.8043 8.12965C27.804 4.59612 25.0293 1.71045 21.5397 1.53347L21.1995 1.52481C17.5521 1.5251 14.5949 4.48225 14.5946 8.12965L14.6008 8.36099H16.788C16.7841 8.28456 16.7818 8.20707 16.7818 8.12965C16.7821 5.6904 18.7602 3.71228 21.1995 3.71199C23.6388 3.71221 25.6169 5.69036 25.6171 8.12965Z",
            fill: "rgb(var(--fill-primary))"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M22.2473 23.941C21.5653 23.9932 21.0547 24.5884 21.1069 25.2704C21.1591 25.9524 21.7543 26.463 22.4364 26.4108C25.6817 26.1624 28.148 23.4551 28.1542 20.2549L28.5671 20.609L28.6676 20.6862C29.1829 21.0447 29.8958 20.9621 30.3133 20.4754C30.7309 19.9886 30.704 19.2715 30.2713 18.8167L30.1797 18.7291L27.5208 16.4483C27.0016 16.0029 26.2199 16.0627 25.7745 16.5819L23.4937 19.2408C23.0483 19.76 23.1082 20.5417 23.6273 20.9871C24.1465 21.4324 24.9283 21.3726 25.3736 20.8534L25.6698 20.5069C25.5402 22.3119 24.1061 23.7987 22.2473 23.941Z",
            fill: "rgb(var(--fill-primary))"
          }
        )
      ]
    }
  );
}
export {
  l as SquareToCircleSwapIcon
};
